import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { TableFiltersOutput, TableFiltersField, TableFiltersOptions, TableFiltersSearchType } from '../../../../models/table-filters';
import { MatMenuTrigger } from '@angular/material/menu';
import { GenericSelectOption } from '../../../../shared/types/signaturit/shared-types';
import { SelectComponent } from '../select/select.component';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { TableService } from '../table/table-service';

@Component({
  selector: 'signaturit-table-filters',
  templateUrl: './table-filters.component.html',
  styleUrls: ['./table-filters.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TableFiltersComponent implements OnInit {
  @Input() fields: TableFiltersField[] = [];

  @Input() title: string = 'Filters';

  @Input() options: TableFiltersOptions = {} as TableFiltersOptions;

  @Input() id: string = '';

  @Output() onFiltersSet: EventEmitter<TableFiltersOutput> = new EventEmitter<TableFiltersOutput>();

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

  @ViewChildren('selector') signaturitSelector: QueryList<SelectComponent>;

  tableFiltersForm: unknown = {};

  _options: TableFiltersOptions = {
    width: 264,
    inline: false,
  };

  eventsSubject: Subject<void> = new Subject<void>();

  constructor(private _tableService: TableService) { }

  ngOnInit(): void {
    this.validateTableForm();
    this.fields.forEach((field) => {
      const { name, typeSearch } = field;
      const isBooleanSearch = typeSearch === TableFiltersSearchType.BOOL;

      if (isBooleanSearch) {
        this.tableFiltersForm[name] = undefined;
      }
    });

    this._options = { ...this._options, ...this.options };
  }

  clear(): void {
    this.fields.forEach((field) => {
      this.tableFiltersForm[field.name] = '';
      if (field.type === 'select') {
        this.signaturitSelector.forEach(select => {
          select.selectedValue = '';
        })
      }
    });
    this.eventsSubject.next();
    this.apply();
  }

  validateTableForm(): void {
    const cacheFilters = this._tableService.getCacheFilters(this.id);
    if (cacheFilters) {
      this.tableFiltersForm = cacheFilters;
      const fieldsSelect = this.fields.filter((value) => value.type === 'select');
      fieldsSelect?.forEach(field => {
        if (this.tableFiltersForm[field.name]) {
          field.selectedOption = this.tableFiltersForm[field.name];
        }
      })
      this.apply()
    }
  }

  apply(): void {
    this.onFiltersSet.emit({
      object: this.tableFiltersForm,
      ODataFilters: this.getODataFilters(this.tableFiltersForm)
    });
    this._tableService.setCacheFilters(this.id, this.tableFiltersForm);
    this.trigger?.closeMenu();
  }

  getODataFilters(filters: unknown): string {
    return Object.keys(filters)
      .map((key) => {
        const field = this.getFieldByName(key);
        const value = filters[key];
        if (value) {
          switch (field.typeSearch) {
            case TableFiltersSearchType.BOOL:
            case TableFiltersSearchType.ID: {
              return `${key} eq ${value}`;
            }
            case TableFiltersSearchType.KEY: {
              return `${key} eq '${value}'`;
            }
            case TableFiltersSearchType.DATE: {
              if (value?.startDate && value?.endDate) {
                return `${key} ge datetime'${value.startDate}' and ${key} le datetime'${value.endDate}'`;
              } else {
                return `year(${key}) eq ${value?.getFullYear()} and month(${key}) eq ${value?.getMonth() + 1} and day(${key}) eq ${value?.getDate()}`;
              }
            }
            case TableFiltersSearchType.SUBSTRING: {
              const filterValue = field.type === 'number' ? value : `'${value?.toUpperCase()}'`;
              if (field.type === 'number') {
                return `${key} eq ${value}`;
              }
              return `substringof(${filterValue}, toupper(${key}))`;
            }
          }
        }
      }).filter((filter) => filter).join(' and ');
  }

  getFieldByName(name: string): TableFiltersField {
    return this.fields.find((field) => field.name === name);
  }

  onSelectOption(event: GenericSelectOption<string | number>, fieldname: string): void {
    this.tableFiltersForm[fieldname] = event?.value;
  }

  onEnterKeyPress(event: KeyboardEvent): void {
    event.preventDefault();
    this.apply();
  }

  getDateRange(event: { startDate: string, endDate: string }, name: string): void {
    this.tableFiltersForm[name] = { startDate: moment(event.startDate).utc(true).format(), endDate: moment(event.endDate).utc(true).hour(23).minute(59).second(59).format() };
  }
}
